<div>
  @if (alertInfo.show) {
    <ngb-alert [type]="alertInfo.type" (closed)="alertInfo.show = false" class="mb-3">
      <strong>{{ alertInfo.type === 'danger' ? 'Error!' : 'Success!' }}</strong>
      <div [innerHTML]="alertInfo.message"></div>
    </ngb-alert>
  }

  @if (!readonly) {
    <div class="mb-4">
      <h5 class="mb-3">{{ isEditing ? 'Edit Previous Job' : 'Add New Job' }}</h5>
      <form [formGroup]="form">
        <div class="row">
          <div class="col-sm-3">
            <input-field [label]="'Engage'" [inputFormControl]="getEngageTimeControl()" [type]="'date'"
              [readonly]="readonly">
          </input-field>
        </div>
        <div class="col-sm-3">
          <input-field [label]="'Termination'" [inputFormControl]="getTerminationTimeControl()"
            [type]="'date'" [readonly]="readonly">
        </input-field>
      </div>
      <div class="col-sm-3">
        <autocomplete-field [label]="'Company'" [placeholder]="'Search...'"
          [inputFormControl]="getCompanyControl()" [readonly]="readonly"
          [displayKeyValue]="true" (valueChange)="onSearchValueChange($event)"
          (optionsLoaded)="onCompanyOptionsLoaded($event)" nameApiSearch="companyName"
          [apiService]="customerService" [apiMethod]="'list'" [minChars]="1" [useApiSearch]="true"
          [optionsKey]="'customers'" [valueOption]="'companyName'" [keyOption]="'customerId'" />
      </div>
      <div class="col-sm-3">
        <input-field [label]="'Role'" [inputFormControl]="getRoleControl()" [readonly]="readonly"
          [placeholder]="'Role'">
      </input-field>
    </div>
  </div>
  <div class="d-flex justify-content-between">
    @if (isEditing) {
      <button type="button" class="btn btn-secondary" (click)="resetForm()">
        Cancel
      </button>
    }
    <button type="button" [disabled]="loading" class="btn btn-primary" (click)="onSubmit()">
      @if (loading) {
        <span class="spinner-border spinner-border-sm me-1" role="status"
        aria-hidden="true"></span>
      }
      {{ isEditing ? 'Update Job' : 'Add Job' }}
    </button>
  </div>
</form>
</div>
}

<h5 class="mb-3">Previous Jobs</h5>
<div class="table-responsive">
  <table class="table table-striped">
    <thead>
      <tr>
        <th>Engage</th>
        <th>Termination</th>
        <th>Company</th>
        <th>Role</th>
        @if (!readonly) {
          <th>Actions</th>
        }
      </tr>
    </thead>
    <tbody>
      @for (job of jobs; track job) {
        <tr>
          <td>{{ job.engageTime | date:'yyyy-MM-dd' }}</td>
          <td>{{ job.terminationTime | date:'yyyy-MM-dd' }}</td>
          <td>{{ job.customer?.companyName }}</td>
          <td>{{ job.role }}</td>
          @if (!readonly) {
            <td>
              <div class="d-flex gap-2">
                <button type="button" class="btn btn-sm btn-outline-primary" (click)="editJob(job)">
                  <i class="fa fa-edit"></i> Edit
                </button>
                <button type="button" class="btn btn-sm btn-outline-danger" (click)="deleteJob(job)">
                  <i class="fa fa-trash"></i> Delete
                </button>
              </div>
            </td>
          }
        </tr>
      }
      @if (jobs.length === 0) {
        <tr>
          <td colspan="5" class="text-center">No previous jobs found</td>
        </tr>
      }
    </tbody>
  </table>
</div>
</div>